export default __webpack_public_path__ + "static/portfolio-img-2-642270beae56b63a4460d03767b59678.png";